import { render, staticRenderFns } from "./DocumentCompanyInfo.vue?vue&type=template&id=965fd8fe&scoped=true&"
import script from "./DocumentCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCompanyInfo.vue?vue&type=style&index=0&id=965fd8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fd8fe",
  null
  
)

export default component.exports